import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ResendCodeButton } from './resend-code-button';
export var ResendCodeButtonContainer = function (_a) {
    var onResendCode = _a.onResendCode, initialCountdown = _a.initialCountdown;
    var _b = useState(initialCountdown), countdown = _b[0], setCountdown = _b[1];
    useEffect(function () {
        if (countdown <= 0)
            return undefined;
        var timerId = setInterval(function () {
            setCountdown(function (prev) { return prev - 1; });
        }, 1000);
        return function () { return clearInterval(timerId); };
    }, [countdown]);
    var handleResendCode = function () {
        onResendCode();
        setCountdown(initialCountdown);
    };
    return _jsx(ResendCodeButton, { onResendCode: handleResendCode, countdown: countdown });
};
